import { Lead } from 'api/leads/leads.type';
import axiosInstance from 'helpers/axiosInstance';
import { useMutation } from 'react-query';

export interface CreateLeadValues {
  leadType: string;
  memberFirstName: string;
  memberLastName: string;
  memberDateOfBirth: string;
  memberPreferredName: string;
  memberSex: string;
  memberGender: string;
  memberPronouns: string;
  memberEthnicity: string;
  memberStreetAddress1: string;
  memberStreetAddress2: string;
  memberCity: string;
  memberState: string;
  memberZipCode: string;
  ayvaPharmacyUid: string;
  pharmacyNcpdpId: string;
  hospitalizationFacility: string;
}
interface CreateLeadResponse {
  lead: Lead;
}

export const useCreateLead = () => {
  return useMutation((values: CreateLeadValues) => {
    return axiosInstance
      .post<CreateLeadResponse>('/patients/leads', values)
      .then(r => r.data.lead);
  });
};
